// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Main-module--bx--text-truncate--end--0zi8F";
export var bxTextTruncateFront = "Main-module--bx--text-truncate--front--0g-R5";
export var main = "Main-module--main--8vph2";
export var padded = "Main-module--padded--HNtoD";